<template>
  <div class="develop-frame">
    <a class="anchor" id="dotJfzlc"></a>
    <div class="home-title-bt">
      <div class="home-t-bg">History</div>
      <p>发展历程</p>
    </div>
    <div
      class="course-main"
      :style="{
        '--histroy-height':
          historyDataList.length * 60 +
          historyDataList[historyDataList.length - 1].up * 18 +
          300 +
          'px',
      }"
    >
      <div class="course-line">
        <div v-for="(history, index) in historyDataList" :key="index">
          <div
            class="course-dian aos-init aos-animate"
            data-aos="zoom-In"
            data-aos-duration="800"
            :style="{ top: index * 60 + history.up * 18 + 'px' }"
          >
            <img src="../../../assets/images/join/lc-dian.png" alt="" />
            <p></p>
          </div>
          <div
            class="aos-init aos-animate"
            :class="index % 2 == 0 ? 'course-data-l' : 'course-data-r'"
            :data-aos="index % 2 == 0 ? 'fade-right' : 'fade-left'"
            data-aos-duration="800"
            :style="{ top: -33 + index * 60 + history.up * 18 + 'px' }"
          >
            <div class="course-data-bg"></div>
            <div class="course-data-main">
              <img
                class="course-j"
                :style="
                  index % 2 == 0
                    ? { right: '-25px', top: '28px' }
                    : { left: '-25px', top: '28px' }
                "
                :src="
                  index % 2 == 0
                    ? require('../../../assets/images/join/bubble.png')
                    : require('../../../assets/images/join/bubble-r.png')
                "
                alt=""
              />
              <div class="course-tit">{{ history.title }}</div>
              <!-- v-html="history.content" -->
              <div class="course-txt" v-html="history.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "develop",
  data() {
    return {
      historys: [
        {
          title: "2015年11月",
          content: "百昌科技集团前身 “上海关门网络科技有限公司” 创立，是国内较早介入 “特殊资产 + 互联网” 行业的企业",
        },
        {
          title: "2016年8月",
          content:
            "“关门网” 正式上线运营，率先在国内推出 O2O 一站式不良资产信息撮合服务",
        },
        {
          title: "2016年12月",
          content:
            "上海市闵行区人民政府正式同意向上海市申报，旗下全资子公司上海市闵行资产投资经营（集团）有限公司和上海关门网络科技有限公司合资成立 “长三角（上海）不良资产交易中心”",
        },
        {
          title: "2017年6月",
          content: "成立技术研发中心和产品研发中心",
        },
        {
          title: "2017年11月",
          content: "董事长黄振宇荣获中国不良资产行业联盟十大风云人物",
        },
        {
          title: "2018年1月",
          content: "百昌科技成立，意为百业昌盛",
        },
        {
          title: "2018年6月",
          content:
            "百昌拍卖平台（网址：www.bcpai.com）上线，同时提出 “全网联拍，共享拍卖” 的商业模式，获上海市商务委颁发拍卖经营许可证",
        },
        {
          title: "2018年11月",
          content: "获溢远投资天使轮投资",
        },
        //25-3-12 remove
        // {
        //   title: "2019年1-11月",
        //   content:
        //     "“百昌拍卖商城-我的资产小店”新品上线，“百昌找律师”系统上线，智能诉讼投资服务平台“WIN赢回来”上线",
        // },
        {
          title: "2019年2月",
          content:
            "与中国长城资产建立 “总对总” 合作关系",
        },
        {
          title: "2019年3月",
          content: "国资入股百昌科技，获上海市闵行资产投资经营（集团）有限公司天使 + 轮融资，正式成为上海联合产权交易所拍卖会员单位，拥有国有资产拍卖资质",
        },
        {
          title: "2019年10月",
          content:
            "百昌拍卖平台新增国有资产租赁权业务板块",
        },
        {
          title: "2019年全年",
          content:
            "上线 “百昌估值地图”、“百昌拍卖商城 - 我的资产小店”、“百昌找律师” 等产品",
        },
        {
          title: "2020年5月",
          content:
            "特殊资产线上 “云” 推介会 ——“恒丰银行 & 百昌科技红 5 月” 启动，成为行业资产营销去化方式范例，同时迎来百昌科技交易季",
        },
        {
          title: "2020年10月",
          content: "百昌科技数字科技板块上线",
        },
        {
          title: "2021年4月",
          content: "中国信达上海区域百亿资产专场上线",
        },
        {
          title: "2021年6月",
          content:
            "成功申请 “竞拍交易方法及系统、计算机可读取存储介质” 发明专利",
        },
        {
          title: "2021年7月",
          content:
            "与华融中关村不良资产交易中心签署战略合作备忘录，百亿中国华融资产专场上线",
        },
        {
          title: "2021年11月",
          content:
            "完成 A 轮融资，由老股东上海市闵行资产投资经营（集团）有限公司继续增资；荣获 “上海市高新技术企业” 称号；浙江子公司成立，迈出特殊资产属地化服务的重要一步",
        },
        // {
        //   title: "2022年1月-12月份",
        //   content:
        //     "安徽、上海、重庆、福建、山东、江西、四川、湖北、广东、河南、东北、河北、广西、甘肃、北京、江苏等地成立子公司。",
        // },
        {
          title: "2022年8月",
          content:
            "百昌科技集团百团大战正式启动，融资租赁与数字百昌两大新业务助力集团发展",
        },
        {
          title: "2022年10月",
          content: "百昌科技集团正式成为广东省破产管理人协会会员单位",
        },
        {
          title: "2022年11月",
          content:
            "百昌科技集团 logo 全新升级、企业官网重磅发布",
        },
        {
          title: "2022年全年",
          content:
            "成立安徽、上海、重庆、福建、山东、江西、四川、湖北、广东、河南、东北、河北、广西、甘肃、北京、江苏等地子公司",
        },
        // {
        //   title: "2023年1月",
        //   content: "北京子公司开业",
        // },
        {
          title: "2023年5月",
          content:
            "北京业务总部设立，标志着以集团为主导、以平台为依托协同发展的商业模式更趋成熟； <br/>服务项目入选 “人民法院十大能动司法（执行）典型案例”",
        },
        {
          title: "2023年7月",
          content:
            "签约加盟商，进一步拓宽全国业务渠道<br/>荣列上海市破产管理人协会首批特邀会员单位",
        },
        {
          title: "2023年8月",
          content: "完成 B + 轮融资",
        },
        {
            title: "2023年9月",
            content: "主办 “中国特殊资产高质量发展暨重整纾困高峰论坛”，超500位行业同仁与会",
        },
        // {
        //     title: "2023年11月",
        //     content: "中国长城资产联合百昌科技集团举办“2023年中国长城商办酒资产推介会",
        // },
        {
            title: "2024年2月",
            content: "荣获长城资产 2023 年度 “资产营销交易 — 最佳渠道伙伴” 奖，获颁 “AAA 企业信用等级证书”",
        },
        {
            title: "2024年3月",
            content: "赢回来一站式个贷智能处置平台发布",
        },
        {
            title: "2024年4月",
            content: "与中国信达签署合作协议，荣膺“2023年度新兴法律服务业领航机构”",
        },
        {
            title: "2024年7月",
            content: "“再查查智能风险管理及线索查控 SaaS 系统” 重磅发布",
        },
        {
            title: "2024年9月",
            content: "协办第八届IPAF会议，此前已入选亚开行研究报告，首次亮相国际舞台",
        },
        {
            title: "2024年12月",
            content: "再查查合作客户已覆盖银行、AMC、融资租赁、信托、国企等多个细分行业",
        },
      ],
    };
  },
  methods: {
    reset_historys() {
      let up = 0;
      return this.historys.map((item, index) => {
        const result = this.splitContent(
          item.content,
          index % 2 == 0 ? 15 : 16
        );
        const r = { ...item, content: result.join(""), up: up };
        up += result.length === 1 ? 2 : result.length;
        return r;
      });
    },
    // splitContent(content, splitNum) {
    //   let result = [];
    //   for (
    //     let i = 0;
    //     i <
    //     Math.floor(content.length / splitNum) +
    //       (content.length % splitNum === 0 ? 0 : 1);
    //     i++
    //   ) {
    //     result.push(
    //       "<p>" +
    //         content.substring(i * splitNum, i * splitNum + splitNum) +
    //         "</p>"
    //     );
    //   }
    //   return result;
    // },
    splitContent(content, splitNum) {
      let result = [];
      if (content.includes("<p>") && content.includes("<p>")) {
        let reg = /<p>.*<\/p>/g;
        return content.match(reg);
      } else {
        for (
          let i = 0;
          i <
          Math.floor(content.length / splitNum) +
            (content.length % splitNum === 0 ? 0 : 1);
          i++
        ) {
          result.push(
            "<p>" +
              content.substring(i * splitNum, i * splitNum + splitNum) +
              "</p >"
          );
        }
      }

      return result;
    },
  },
  computed: {
    historyDataList: function() {
      return this.reset_historys();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$AOS.init();
    });
  },
};
</script>

<style scoped lang="scss">
.develop-frame {
  position: relative;
  .anchor {
    position: absolute;
    opacity: 0;
    top: -200px;
  }
  .course-main {
    position: relative;
    height: var(--histroy-height, 900px);
    .course-line {
      position: absolute;
      border-left: 4px dotted #0066c0;
      width: 500px;
      height: calc(100% - 220px);
      top: 80px;
      left: 50%;
      margin-left: -2px;
      .course-dian {
        position: absolute;
        top: -9px;
        left: -11px;
        overflow: hidden;
        width: 18px;
        height: 18px;
        img {
          width: 18px;
          height: 18px;
          display: block;
        }
      }
    }
    .course-data-l {
      position: absolute;
      left: -316px;
    }
    .course-data-r {
      position: absolute;
      left: 48px;
    }
    .course-data-bg {
      width: 100%;
      height: 100%;
      background-color: rgba(203, 230, 255, 0.32);
      position: absolute;
      bottom: -7px;
      right: -5px;
      border-radius: 5px;
    }
    .course-data-main {
      position: relative;
      min-width: 265px;
      padding: 20px 27px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #e1dddd;
      white-space: normal;
      border-radius: 5px;
      font-family: "SourceHanSansCN-Regular";
      .course-j {
        width: 25px;
        height: 32px;
        position: absolute;
        top: 20px;
      }
      .course-tit {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
      }
      .course-txt {
        padding-top: 6px;
        font-size: 14px;
        color: #666;
        line-height: 24px;
      }
    }
  }
}
</style>
